module.exports = __webpack_public_path__ + "static/body_1-7ec2f705bdc8d6c9712fbe5e019f5ad7.png";